import CampaignsBarTablet from "../CampaignsBarTablet/CampaignsBarTablet";

function CampaignsBar(props) {
  const { currentPageKey } = props;
  return (
    <>
      <div>
        <CampaignsBarTablet currentPageKey={currentPageKey} />
      </div>
    </>
  );
}

export default CampaignsBar;
